import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

export const StTitleText = styled('h2')(({ theme }) => ({
  fontFamily: theme?.palette?.primaryFontFamilyType || 'Proxima Nova',
  fontStyle: 'normal',
  fontWeight: '600',
  fontSize: '32px',
  lineHeight: '32px',
  [theme.breakpoints.down('lg')]: {
    fontSize: '30px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '20px',
  },
}));

export const StTitleIconContainer = styled(Grid)(({ theme }) => ({
  margin: '0',

  [theme.breakpoints.down('sm')]: {
    margin: '0 0 12px 0',
  },
}));

export const IconWrapper = styled('div')(({}) => ({
  display: 'flex',
  alignItems: 'center',
}));

export const ShareAndDownloadWrapper = styled('div')(({}) => ({
  marginTop: '40px',
  paddingBottom: '45px',
}));
